import { User } from '@/modules/User/interfaces/user'
import { Account } from '@/modules/Account/interfaces/account'

export enum DocusignDocumentType {
  TEMPLATE='TEMPLATE',
  ACORDFORM='ACORDFORM'
}

export interface DocusignEnvelope {
  id: number
  clientName: string
  clientEmail: string
  ccName: string
  ccEmail: string
  subject: string
  message: string
  signers: [DocusignEnvelopeSigner]
  cc: [DocusignRecipient]
  status: string
  sentDate: number
  completedDate: number
  documents: [DocusignDocument]
  createdAt: number
  updatedAt: number
  createdBy: User
  lastModifiedBy: User
  vergeStaff:User
  account: Account
}
interface DocusignEnvelopeSigner{
  signAnchors: [string]
  dateSignAnchors: [string]
  routingOrder: number
  recipient: DocusignRecipient
  signStatus: string
}

interface DocusignRecipient {
  name: string
  email: string
}
interface DocusignDocument {
  id:number
  name: string
  extension: string
  originUrl: string
  documentId: string
  type: DocusignDocumentType
  signedUrl: string
  templateParams: [DocusignTemplateParam]
  createdAt: number
  updatedAt: number
}
interface DocusignTemplateParam {
  keyname: string
  value: string
}
